import {inject, Injectable} from '@angular/core';
import {Navigation} from 'app/core/navigation/navigation.types';
import {combineLatest, map, Observable, of, ReplaySubject, tap} from 'rxjs';
import {navigationItems} from "./navigation";
import {UserService} from "../user/service/user.service";
import {FuseNavigationItem} from "../../../@fuse/components/navigation";

@Injectable({providedIn: 'root'})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);
    private userService: UserService = inject(UserService)

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return combineLatest([
            this._navigation.asObservable(),
            this.userService.isAdmin$()
        ]).pipe(
            map(([navi, isAdmin]: [Navigation, boolean]) => {
                return {
                    default: this.filterItems(navi.default, isAdmin),
                    compact: this.filterItems(navi.compact, isAdmin),
                    futuristic: this.filterItems(navi.futuristic, isAdmin),
                    horizontal: this.filterItems(navi.horizontal, isAdmin),
                } as Navigation;
            })
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        this._navigation.next(navigationItems);

        return of(navigationItems);
    }

    filterItems(items: FuseNavigationItem[], isAdmin: boolean): FuseNavigationItem[] {
        return items.filter(item => {
            if (isAdmin) {
                return item.role === 'ADMIN';
            }

            return item.role === 'USER';
        })
    }
}
